import { fetchAuthSession } from "@aws-amplify/auth";
import { uploadImagesUrl } from "./url";

export const mediaApi = {
  uploadImages: async (formData) => {
    const session = await fetchAuthSession();
    const idToken = session.tokens?.idToken?.toString() ?? "";
    const refreshToken = session.tokens?.accessToken?.toString() ?? "";

    const response = await fetch(uploadImagesUrl(), {
      method: "POST",
      headers: {
        Authorization: idToken,
        refreshToken,
        platform: "2",
        appType: "0",
        "Accept-Language": "en",
      },
      body: formData,
    });

    if (!response.ok) {
      return Promise.reject(response);
    }

    return response.json();
  },
};
